
const SIGN_IN_LOCALE_TEMPLATES = {
    "en": {
        "sign.in.title": "Log in to get started",
        "sign.in.email": "Email",
        "sign.in.password": "Password",
        "sign.in.forgot.password": "Forgot your password?",
        "sign.in.separator": "or",

        "sign.in.both.fields.popup": "Both fields are required",
        "sign.in.mvp.deprecated": "This login is no longer supported",
    },
    "nl": {
        "sign.in.title": "Log in om te starten",
        "sign.in.email": "Emailadres",
        "sign.in.password": "Wachtwoord",
        "sign.in.forgot.password": "Wachtwoord vergeten?",
        "sign.in.separator": "of",

        "sign.in.both.fields.popup": "Beide velden zijn verplicht",
        "sign.in.mvp.deprecated": "Deze inlog wordt niet meer ondersteund",
    }
}

export default SIGN_IN_LOCALE_TEMPLATES;
